import { render } from "./legoFormBox.vue?vue&type=template&id=52ab4223"
import script from "./legoFormBox.vue?vue&type=script&lang=js"
export * from "./legoFormBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/boxes/legoFormBox/legoFormBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52ab4223"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52ab4223', __exports__)) {
    api.reload('52ab4223', __exports__)
  }
  
  module.hot.accept("./legoFormBox.vue?vue&type=template&id=52ab4223", () => {
    api.rerender('52ab4223', render)
  })

}


export default __exports__